var render = function render(_c,_vm){return _c('div',{staticClass:"foo"},[(!_vm.props.row.imageUrl)?_c('el-avatar',{attrs:{"size":"small","src":"/static/images/avatar-2.jpg"}}):_c('el-avatar',{attrs:{"size":"small","src":_vm.props.row.imageUrl}}),_c('span',[_vm._v(_vm._s(_vm.props.row.Name)+" "+_vm._s(_vm.props.row.LastName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }